function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.3999 16.7998H19.5999",
  stroke: "#02BC4D",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.3999 11.1997H19.5999",
  stroke: "#02BC4D",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5999 26.5999H9.3999C8.84762 26.5999 8.3999 26.1522 8.3999 25.5999V10.4604C8.3999 9.57821 8.69153 8.72078 9.22941 8.02155L11.6925 4.81949C11.827 4.64468 11.8999 4.43032 11.8999 4.20978V2.3999C11.8999 1.84762 12.3476 1.3999 12.8999 1.3999H15.0999C15.6522 1.3999 16.0999 1.84762 16.0999 2.3999V4.20978C16.0999 4.43032 16.1728 4.64468 16.3073 4.81949L18.7704 8.02155C19.3083 8.72078 19.5999 9.57821 19.5999 10.4604V25.5999C19.5999 26.1522 19.1522 26.5999 18.5999 26.5999Z",
  stroke: "#151515",
  strokeWidth: 2
});

var SvgDrinks = function SvgDrinks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDrinks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drinks.10566575.svg";
export { ForwardRef as ReactComponent };